import { FC } from 'react'
import { ScoreGridCategory } from '../../evaluation/ScoreGridCategory.enum'
import { useTranslation } from 'react-i18next'
import PerButton from '../../../../components/custom_components/Button'
import PerFlexRow from '../../../../components/custom_components/FlexRow'
import '../../evaluation/evaluation.less'

interface Props {
  tabs: { id: string; title: string }[]
  activeCategory: ScoreGridCategory
  onChangeTabButtonClicked: (nextCategory: ScoreGridCategory) => void
}

const TabSwitchingButtons: FC<Props> = ({ tabs, activeCategory, onChangeTabButtonClicked }) => {
  const [t] = useTranslation()

  const nextTabId = (): string => {
    if (tabs.findIndex((tab) => tab.id === activeCategory) + 1 < tabs.length) {
      const entry = tabs[tabs.findIndex((tab) => tab.id === activeCategory) + 1].id
      return entry
    } else return ''
  }

  const previousTabId = (): string => {
    if (tabs.findIndex((tab) => tab.id === activeCategory) - 1 >= 0) {
      const entry = tabs[tabs.findIndex((tab) => tab.id === activeCategory) - 1].id
      return entry
    } else return ''
  }
  return (
    <PerFlexRow justify="space-between" className="per-evaluation-tabSwitchingBtn--wrapper">
      {previousTabId() ? (
        <PerButton
          text={t(`appraisalMeeting.evaluation.grid.category.${previousTabId()}`)}
          size="small"
          before="chevronLeft_stroke"
          tabIndex={-1}
          onClick={() => onChangeTabButtonClicked(ScoreGridCategory[previousTabId() as keyof typeof ScoreGridCategory])}
          color="secondary"
          variant="pastel"
        />
      ) : (
        <div />
      )}
      {nextTabId() ? (
        <PerButton
          text={t(`appraisalMeeting.evaluation.grid.category.${nextTabId()}`)}
          data-e2e-next-tab-button
          size="small"
          after="chevronRight_stroke"
          onClick={() => onChangeTabButtonClicked(ScoreGridCategory[nextTabId() as keyof typeof ScoreGridCategory])}
          color="primary"
          variant="pastel"
        />
      ) : (
        <div />
      )}
    </PerFlexRow>
  )
}

export default TabSwitchingButtons
